import React from "react";
import DynamicChart from "./DynamicChart";

const PPS = () => {
  return (
    <div className="p-5 h-full">
      <div className="bg-white border border-gray-200 rounded-md flex-grow">
        <DynamicChart />
      </div>
    </div>
  );
};

export default PPS;
